var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 6.1875C19.25 4.28902 17.711 2.75 15.8125 2.75C13.914 2.75 12.375 4.28902 12.375 6.1875C12.375 8.08598 13.914 9.625 15.8125 9.625C17.711 9.625 19.25 8.08598 19.25 6.1875Z",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 6.1875C9.625 4.28902 8.08598 2.75 6.1875 2.75C4.28902 2.75 2.75 4.28902 2.75 6.1875C2.75 8.08598 4.28902 9.625 6.1875 9.625C8.08598 9.625 9.625 8.08598 9.625 6.1875Z",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 15.8125C19.25 13.914 17.711 12.375 15.8125 12.375C13.914 12.375 12.375 13.914 12.375 15.8125C12.375 17.711 13.914 19.25 15.8125 19.25C17.711 19.25 19.25 17.711 19.25 15.8125Z",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 15.8125C9.625 13.914 8.08598 12.375 6.1875 12.375C4.28902 12.375 2.75 13.914 2.75 15.8125C2.75 17.711 4.28902 19.25 6.1875 19.25C8.08598 19.25 9.625 17.711 9.625 15.8125Z",
    stroke: "#171615",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.b788fc1d32fdefea5e83e9d370a15230.svg";
export { ForwardRef as ReactComponent };